import { Component, OnInit } from '@angular/core';
// import { Facebook } from '@awesome-cordova-plugins/facebook/ngx';
import { GooglePlus } from '@awesome-cordova-plugins/google-plus/ngx';
import { NativeStorage } from '@awesome-cordova-plugins/native-storage/ngx';
import { SocialSharing } from '@awesome-cordova-plugins/social-sharing/ngx';
import {
  ActionSheetController,
  AlertController,
  LoadingController,
  ModalController,
  NavController,
  Platform,
} from '@ionic/angular';
import { GlobalVariable } from '../global';
import { ServerService } from '../providers/server.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.page.html',
  styleUrls: ['./settings.page.scss'],
})
export class SettingsPage implements OnInit {
  phonenumber: any;
  phonecode: any = '+1';
  profiledata: any;
  aniversayexist: boolean = false;
  birthday_exist: boolean = false;
  phone_verify: any;
  code: any;
  user_aniversary: any = '';
  user_birthday: any = '';
  // @ViewChild(Navbar) navBar: Navbar;
  url: any;
  user_id: any;
  user_date: any;
  image: any;
  udid: any;
  data: any;
  socialLogin = 'false';
  user_email: any;
  firstname: any;
  lastname: any;
  phone: any;
  password: any;
  lockWallet: boolean = false;
  Unedit: boolean = true;
  nameCard = false;
  emailCard = false;
  phoneCard = false;
  passwordCard = false;
  QRurl = '';
  formatedPhone: string;
  constructor(
    public googlePlus: GooglePlus,
    // private facebook: Facebook,

    public server: ServerService,
    // private pinDialog: PinDialog,
    public globals: GlobalVariable,
    public modalCtrl: ModalController,
    private socialSharing: SocialSharing,
    private nativeStorage: NativeStorage,
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController,

    public actionSheetCtrl: ActionSheetController,
    public navCtrl: NavController,

    public platform: Platform
  ) {
    this.data = {};
    this.data.response = '';
  }
  ionViewWillEnter() {
    let social = localStorage.getItem('isSocialLogin');

    if (social != null || social != undefined) {
      this.socialLogin = social;
    }
    //   this.navBar.backButtonClick = (e:UIEvent)=>{
    //       // todo something
    //       this.StorWalletLock();
    //       this.navCtrl.pop();
    //     //   let nav = this.app.getRootNav();
    //     //   nav.setRoot(MainTabsPage, {tabIndex: 0});

    //   }
    console.log('ionViewDidLoad SettingPage');
    if (this.platform.is('ios')) {
      this.url = 'https://itunes.apple.com/app/';
    } else if (this.platform.is('android')) {
      this.url = 'https://play.google.com/store/apps/';
    }

    this.getuserNativeData();

    // this.getWalletCheckFlag();
  }
  ngOnInit() {}
  ionViewDidLoad() {}
  ionViewWillLeave() {
    console.log('did leave settings');

    this.StorWalletLock();
  }
  showNameCard() {
    if (this.nameCard == true) {
      this.nameCard = false;
    } else {
      this.nameCard = true;
      this.emailCard = false;
      this.passwordCard = false;
      this.phoneCard = false;
    }
  }
  showEmailCard() {
    if (this.emailCard == true) {
      this.emailCard = false;
    } else {
      this.emailCard = true;
      this.nameCard = false;
      this.passwordCard = false;
      this.phoneCard = false;
    }
    // this.emailCard=true;
  }
  showPhoneCard() {
    if (this.phoneCard == true) {
      this.phoneCard = false;
    } else {
      this.phoneCard = true;
      this.nameCard = false;
      this.passwordCard = false;
      this.emailCard = false;
    }
    // this.emailCard=true;
  }

  showPasswordCard() {
    if (this.passwordCard == true) {
      this.passwordCard = false;
    } else {
      this.passwordCard = true;
      this.nameCard = false;
      this.emailCard = false;
      this.phoneCard = false;
    }
    // this.passwordCard=true;
  }

  getuserNativeData() {
    this.nativeStorage
      .getItem('user')
      .then((data) => {
        console.log('data user', data);
        this.user_email = data.email;
        this.firstname = data.firstName;
        this.lastname = data.lastName;
        this.phonenumber = data.phone;
        // this.password = data.password;

        this.image = data.image;
        this.user_date = data.date;
        this.user_id = data.ID;
        this.user_birthday = data.birthday;
        this.user_aniversary = data.aniversary;
        this.phone_verify = data.phone_verify;
        this.QRurl = data.image;

        console.log(
          'native storage user data',
          data.email,
          'first name',
          data.firstName,
          data.lastName,
          data.phone
        );
        this.phonenumber = localStorage.getItem('userphone');

        // if (this.phonenumber.charAt(1) == "9") {
        //   console.log("9");
        //   this.phonecode = this.phonenumber.slice(0, 3);
        // } else {
        //   console.log("1");
        //   this.phonecode = this.phonenumber.slice(0, 2);
        // }
        console.log(
          'native phone number ...... ',
          this.phonecode,
          this.phonenumber
        );
        // this.phone = this.phonenumber.replace(this.phonecode, '');
        this.phone = this.phonenumber;
        this.phone = Number(this.phone);
        console.log(this.phone);

        console.log(this.phonecode, this.phone);

        // console.log("special", this.user_birthday, this.user_aniversary);

        console.log(this.user_birthday);
        if (this.user_aniversary == 'N/A') {
          this.aniversayexist = false;
        } else if (this.user_aniversary.toString().length > 0) {
          this.aniversayexist = true;
        }

        if (this.user_birthday == 'N/A') {
          this.birthday_exist = false;
        } else if (this.user_birthday.toString().length > 0) {
          this.birthday_exist = true;
        }
      })
      .catch((err) => console.log);

      let email = localStorage.getItem('userEmail');
      if(email!='null' && email!=null){
        this.user_email=email;
      }
  }

  StorWalletLock() {
    this.nativeStorage
      .setItem('walletlock', { walletCheck: this.lockWallet })
      .then(
        () => console.log('Stored wallet lock'),
        (error) => console.error('Error storing item', error)
      );
  }
 

  getWalletCheckFlag() {
    this.nativeStorage
      .getItem('walletlock')
      .then((data) => {
        console.log(data);
        this.lockWallet = data.walletCheck;
        this.globals.WallletLock = this.lockWallet;
      })
      .catch((err) => console.log);
  }

  //     ionViewWillLeave(){
  //         console.log("Looks like I'm about to leave :(");
  //         this.nativeStorage.getItem('user')
  //         .then(data => {
  //             this.user_email = data.email;
  //             this.firstname = data.firstName;
  //             this.lastname = data.lastName;
  //             this.phone = data.phone;
  //             this.password = data.password;
  //             this.udid = data.udid;
  //             this.image = data.image;
  //             this.user_date = data.date;
  //             this.user_id = data.ID;
  //             this.user_birthday = data.birthday;
  //             this.user_aniversary = data.aniversary;
  //             this.phone_verify = data.phone_verify;

  //         }).catch(err => console.log);

  //   }

  //   ionViewWillEnter(){
  //     console.log("Enter");
  //     this.nativeStorage.getItem('user')
  //     .then(data => {
  //         this.user_email = data.email;
  //         this.firstname = data.firstName;
  //         this.lastname = data.lastName;
  //         this.phonenumber = data.phone;
  //         this.password = data.password;
  //         this.udid = data.udid;
  //         this.image = data.image;
  //         this.user_date = data.date;
  //         this.user_id = data.ID;
  //         this.user_birthday = data.birthday;
  //         this.user_aniversary = data.aniversary;
  //         this.phone_verify = data.phone_verify;

  //         console.log(this.image,"image");
  //         if(this.phonenumber.charAt(1) == '9')
  //             {
  //                 console.log("9")
  //                 this.phonecode = this.phonenumber.slice(0,3);

  //             }
  //             else{
  //                 console.log("1")
  //                  this.phonecode = this.phonenumber.slice(0,2);

  //             }
  //             console.log(this.phonecode,this.phonenumber);
  //             this.phone = this.phonenumber.replace(this.phonecode,'');
  //             this.phone = Number(this.phone);

  //         console.log(this.phonecode,this.phone);

  //         console.log("special",this.user_birthday,this.user_aniversary)

  //         console.log(this.user_birthday);
  //         if(this.user_aniversary == 'N/A')
  //         {
  //             this.aniversayexist = false;
  //         }
  //         else if (this.user_aniversary.toString().length > 0)
  //         {
  //             this.aniversayexist =true;
  //         }

  //         if(this.user_birthday == 'N/A')
  //         {
  //             this.birthday_exist = false;
  //         }
  //         else if(this.user_birthday.toString().length > 0)
  //         {
  //             this.birthday_exist = true;
  //         }

  //     }).catch(err => console.log);

  // }

  // logout() {

  //     this.nativeStorage.clear()
  //         .then(data => {

  //             this.nativeStorage.remove('user')
  //                 .then(data => {
  //                     console.log('data removed');

  //                     this.app.getRootNav().setRoot('LoginPage');
  //                 }).catch(err => console.log());

  //             console.log(data);
  //             this.globals.Product.length = 0;
  //             this.lockWallet = false;
  //             this.globals.cartflag = false;

  //         }).catch(err => console.log());

  // }

  // public presentActionSheet() {

  //     let actionSheet = this.actionSheetCtrl.create({
  //         title: 'Share Jack Jacks Coffee House',
  //         buttons: [
  //             {
  //                 text: 'Via Facebook',
  //                 icon: 'logo-facebook',
  //                 handler: () => {
  //                     this.ShareViaFacebook('Hey this app is great!', null, this.url);
  //                 }
  //             },
  //             {
  //                 text: 'Via Whatsapp',
  //                 icon: 'logo-whatsapp',
  //                 handler: () => {
  //                     this.whatsappShare('Hey this app is great!', null, this.url);
  //                 }
  //             },
  //             {
  //                 text: 'Via SMS',
  //                 icon: 'mail',
  //                 handler: () => {
  //                     this.SMS();
  //                 }
  //             },
  //             {
  //                 text: 'Cancel',
  //                 icon: 'close',
  //                 role: 'cancel'
  //             }
  //         ]
  //     });
  //     actionSheet.present();
  // }

  whatsappShare(message, image, url) {
    this.platform.ready().then(() => {
      this.socialSharing
        .shareViaWhatsApp(message, image, url)
        .then(() => {
          console.log('Success');
        })
        .catch(() => {
          // Error!
          //   alert("Failed");
        });
    });
  }
  ShareViaFacebook(message, image, url) {
    this.platform.ready().then(() => {
      this.socialSharing
        .shareViaFacebook(message, image, url)
        .then(() => {
          console.log('Success');
        })
        .catch(() => {
          // Error!
          //   alert("Failed");
        });
    });
  }

  // SMS() {
  //     var options = {
  //         replaceLineBreaks: true, // true to replace \n by a new line, false by default
  //         android: {
  //             intent: 'INTENT'  // Opens Default sms app
  //             //intent: '' // Sends sms without opening default sms app
  //         }
  //     }
  //     this.smsVar.send('', this.url, options)
  //         .then(() => {
  //             console.log("success");
  //         }, () => {
  //             //  alert("failed");
  //         });
  // }

  numberChange() {
    console.log('here');
    // this.phonenumber = String(phonenumber);
    var cleaned = ('' + this.phonenumber).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{0,3})(\d{0,4})$/);
    if (match) {
      this.formatedPhone =
        '(' + match[1] + ') ' + (match[2] ? match[2] + '-' : '') + match[3];
      //  this.phonenumber= this.formatedPhone
      console.log(this.formatedPhone);
    }
    // var match = cleaned.match( /^(\d{3})(\d{3})(\d{4})$/)
    // if (match) {

    //     console.log('match')
    //   this.formatedPhone= '(' + match[1] + ') ' + match[2] + '-' + match[3]
    // }
    return null;
    // var clean = this.formatedPhone.replace(/[^\d]/g, '')
    // console.log(clean)
    // this.formatedPhone = clean.replace(/[0-9]{3}-[0-9]{3}-[0-9]{4}/g,'');
    // console.log(this.formatedPhone)
  }
  async submit() {
    if (this.user_birthday != '') {
      this.birthday_exist = true;
    }
    if (this.user_aniversary != '') {
      this.aniversayexist = true;
    }
    var cleaned = ('' + this.formatedPhone).replace(/\D/g, '');
    let udid = localStorage.getItem('udid');
    let email = localStorage.getItem('userEmail');

    let response = this.server.UpdateUserProfile(
      this.firstname,
      email,
      this.lastname,
      this.password,
      this.phonecode + cleaned,
      udid
    );
    let loading = await this.loadingCtrl.create({
      message: 'Please wait...',
    });
    loading.present();

    response.subscribe(
      async (data) => {
        loading.dismiss();
        this.data.response = data;
        console.log('update profile', this.data.response);
        console.log(this.data.response.success);
        if (this.data.response.success == true) {
          if (
            data.updated_data.phone != null &&
            data.updated_data.phone != ''
          ) {
            localStorage.setItem('userphone', data.updated_data.phone);
            this.phonenumber = data.updated_data.phone;
          }
          localStorage.setItem('userEmail',this.data.response.updated_data.email);

          console.log(this.data.response.updated_data.first_name);
          this.nativeStorage
            .setItem('user', {
              firstName: this.data.response.updated_data.first_name,
              lastName: this.data.response.updated_data.last_name,
              phone: this.data.response.updated_data.phone,
              password: this.data.response.updated_data.password,
              udid: this.data.response.updated_data.udid,
              image: this.data.response.updated_data.image,
              ID: this.user_id,
              date: this.data.response.updated_data.date_joined,
              email: this.data.response.updated_data.email,
              birthday: this.data.response.updated_data.birthday,
              aniversary: this.data.response.updated_data.anniversary,
              phone_verify: this.phone_verify,
            })
            .then(async () => {
              console.log(this.image);
              let alert = await this.alertCtrl.create({
                header: 'Success',
                subHeader: 'Profile successfully updated.',

                buttons: ['Okay'],
              });

              alert.present();
              this.navCtrl.navigateRoot('home');
            })
            .catch(async (err) => {
              console.log(err);
            });
        } else {
          let alert = await this.alertCtrl.create({
            header: 'Error!',
            subHeader: 'Profile update failed. Please try again.',

            buttons: ['Okay'],
          });
          loading.dismiss();
          alert.present();
        }
      },
      (error) => {
        console.log('Oooops!', error);
      }
    );
  }

  OpenTermsAndPolicy() {
    this.navCtrl.navigateForward('terms-privacy');
  }
  OpenContactUs() {
    this.navCtrl.navigateForward('contact-us');
  }

  walletCheck() {
    console.log(this.lockWallet);
    if (this.lockWallet == true) {
      // this.verifytrueCheck();
    } else {
      // this.confirmCode();
    }
  }
  SaveLockCode() {
    this.nativeStorage
      .setItem('lock', {
        walletCode: btoa(this.globals.code),
      })
      .then(
        () => console.log('Stored item!'),
        (error) => console.error('Error storing item', error)
      );
  }

  // confirmCode() {
  //   this.nativeStorage
  //     .getItem("lock")
  //     .then((data) => {
  //       this.code = atob(data.walletCode);
  //       this.pinDialog
  //         .prompt("Enter your PIN", "Verify PIN", ["Cancel", "Okay"])
  //         .then((result: any) => {
  //           if (result.buttonIndex == 2) {
  //             console.log("User clicked OK, value is: ", result.input1);
  //             if (this.code == result.input1) {
  //               this.lockWallet = false;
  //               this.globals.WallletLock = this.lockWallet;
  //             } else {
  //               this.lockWallet = true;
  //               let alert = this.alertCtrl.create({
  //                 title: "Error",
  //                 subTitle: "Incorrect password.",

  //                 buttons: ["Okay"],
  //               });

  //               alert.present();
  //             }
  //           } else if (result.buttonIndex == 1) {
  //             console.log("User cancelled");
  //           }
  //         });
  //     })
  //     .catch((err) => console.log);
  // }
  // verifytrueCheck() {
  //   this.pinDialog
  //     .prompt("Enter your PIN", "PIN", ["Submit", "Cancel"])
  //     .then((result: any) => {
  //       if (result.buttonIndex == 1) {
  //         console.log("User clicked submit, value is: ", result.input1);
  //         this.code = result.input1;

  //         this.pinDialog
  //           .prompt("Confirm your PIN", "Verify PIN", ["Cancel", "Okay"])
  //           .then((result: any) => {
  //             if (result.buttonIndex == 2) {
  //               console.log("User clicked OK, value is: ", result.input1);
  //               if (this.code == result.input1) {
  //                 this.globals.code = this.code;
  //                 this.SaveLockCode();
  //                 this.lockWallet = true;
  //                 this.globals.WallletLock = this.lockWallet;
  //                 console.log(this.globals.WallletLock);
  //               } else {
  //                 this.PinCheck();
  //               }
  //             } else if (result.buttonIndex == 1) {
  //               console.log("User cancelled");
  //               this.lockWallet = false;
  //               this.globals.WallletLock = this.lockWallet;
  //             }
  //           });
  //       } else if (result.buttonIndex == 2) {
  //         console.log("User cancelled");
  //         this.lockWallet = false;
  //         this.globals.WallletLock = this.lockWallet;
  //       }
  //     });

  //   // });
  // }

  // PinCheck() {
  //   this.pinDialog
  //     .prompt("PIN does not match", "Verify PIN", ["Cancel", "Okay"])
  //     .then((result: any) => {
  //       if (result.buttonIndex == 2) {
  //         console.log("User clicked OK, value is: ", result.input1);
  //         if (this.code == result.input1) {
  //           this.globals.code = this.code;
  //           this.SaveLockCode();
  //           this.lockWallet = true;
  //           this.globals.WallletLock = this.lockWallet;
  //         } else {
  //           let alert = this.alertCtrl.create({
  //             title: "Error",
  //             subTitle: "Incorrect password.Please try again.",

  //             buttons: ["Okay"],
  //           });

  //           alert.present();
  //         }
  //       } else if (result.buttonIndex == 1) {
  //         console.log("User cancelled");
  //       }
  //       this.lockWallet = false;
  //       this.globals.WallletLock = this.lockWallet;
  //     });
  // }

  // verify(){

  //     this.touchId.verifyFingerprint('Scan your fingerprint to unlock').then((res) => {

  //         this.lockWallet = false;
  //         this.globals.WallletLock = this.lockWallet;
  //     }, (err) => {
  //         console.log(err);
  //         this.lockWallet = true;
  //         this.globals.WallletLock = this.lockWallet;
  //     });

  // }

  Edit() {
    this.Unedit = false;
  }
  async logout() {
    const alert = await this.alertCtrl.create({
      header: 'Logout',
      cssClass: 'customAlert',
      message:
        'You are about to logout. This will clear your cart and saved information.',
      buttons: [
        {
          text: 'Stay Logged in',
          cssClass: 'cancel_btn',
          handler: (data) => {
            // this.showProfileCard = false;
            // this.showNotif = false;
            console.log('Cancel clicked');
          },
        },
        {
          text: 'Logout',
          handler: (data) => {
           this.signOut()
          },
        },
      ],
    });
    await alert.present();
    // this.nativeStorage.remove('user').then(data => {

    // }).catch(err => console.log());
  }

signOut(){
   // this.showProfileCard = false;
   this.globals.Product.length = 0;
   this.globals.cartflag = false;
   this.globals.guess_login = true;
   this.globals.laterAskPhone = false;
   localStorage.removeItem('isLogin');
   localStorage.removeItem('firstname');
   localStorage.removeItem('addresses');
   localStorage.removeItem('myFavorites');
   localStorage.removeItem('userphone');
   localStorage.removeItem('paymentmethods');
   localStorage.removeItem('udid');
   localStorage.removeItem('user');
   localStorage.removeItem('userEmail');
   localStorage.setItem('isSocialLogin', JSON.stringify(false));
   this.nativeStorage
     .remove('user')
     .then((data) => {})
     .catch((err) => console.log());
   this.nativeStorage
     .remove('card')
     .then((data) => {})
     .catch((err) => console.log());

   //logout from google
   this.googlePlus.logout().then((res) => {
     console.log('google login cleared', res);
   });
   //logout from fb
  //  this.facebook.getLoginStatus().then((res) => {
  //    console.log('facebook login status response', res);
  //    if (res.status === 'connected') {
  //      this.facebook
  //        .logout()
  //        .then((res) => {
  //          console.log('logout from facebook', res);
  //        })
  //        .catch((err) => {
  //          console.log('fb failed logout', err);
  //        });
  //    }
  //  });

   // this.app.getRootNav().setRoot("LandingPage");
   this.navCtrl.navigateRoot('home');
}

  deleteProfile(){
    this.globals.Loader()
    this.server.deleteUserAccount().subscribe(res=>{
      console.log(res);
      this.globals.loading.dismiss();


      if(res.success==true){
        this.globals.presentToast('Account deleted',3000,'middle');
        // this.signOut();
        this.signOut();

      }
      else{
        this.globals.presentToast('failed to delete',2000,'middle');

      }

    },err=>{
      this.globals.loading.dismiss();
      this.globals.presentToast('Network error')

    })
  }
  // signOut() {
  //   let branch= localStorage.getItem('activeBranchid');
  //   let kiosk=JSON.parse(localStorage.getItem('kiosk'))
  //   console.log('kioskfromlocal',kiosk)
  //   if(kiosk!=null){
  //       this.globals.kiosk_flag=kiosk;}
  //   this.storage.remove('loginData').then(res => {
  //     this.isLoggedIn = false;
      
  //     this.localStorageService.clearAll();
  //     this.storage.clear();
  //     this.localStorageService.setTour('Tour', JSON.stringify(true));
  //   localStorage.setItem('kiosk',JSON.stringify(this.globals.kiosk_flag));
  //     console.log('logged out ', res)
  //     this.nativeStorage.clear();
  //     // console.log('logged out kiosk ', k)
  //     this.globals.itemsInCart=[];
  //     this.globals.isloggedIn = false;
  //     localStorage.setItem('activeBranchid',branch);
  //     this.navCtrl.navigateRoot('/tabs/tabs/home');
  //     // this..navigate(['../tabs/tabs/home'])
  //     // window.location.reload();
  //   });
  // }
  async deleteConfirm() {
    const alert = await this.alertCtrl.create({
      header: 'Delete Account',
      message: "Your're about to delete your account, All your points and rewards will be gone.",
      mode:'ios',

      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel: blah');
          }
        }, {
          text: 'Delete',
          handler: () => {
            console.log('Confirm Okay');
           this.deleteProfile();

          }
        }
      ]
    });
  
    await alert.present();
  }
}
